import React, { useState, useEffect } from 'react';
import dailyReviewService from '../../services/dailyReviewService';
import './GoalFeatureSelector.css';

const GoalFeatureSelector = ({ projectId, onSelect, selectedFeatureIds = [], features: providedFeatures }) => {
    const [features, setFeatures] = useState(providedFeatures || []);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (providedFeatures) {
            setFeatures(providedFeatures);
        } else if (projectId) {
            fetchFeatures();
        }
    }, [projectId, providedFeatures]);

    const fetchFeatures = async () => {
        try {
            setLoading(true);
            const data = await dailyReviewService.getGoalsData(projectId);
            setFeatures(data.features || []);
        } catch (error) {
            console.error('Error fetching features:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredFeatures = features.filter(feature => {
        if (selectedFeatureIds.includes(feature.id)) return false;
        const searchLower = searchTerm.toLowerCase();
        return feature.name?.toLowerCase().includes(searchLower);
    });

    const handleSelect = (feature) => {
        onSelect({
            featureId: feature.id,
            featureName: feature.name,
            target: 'complete-today',
            status: 'pending',
            addedAt: new Date().toISOString()
        });
        setSearchTerm('');
        setIsOpen(false);
    };

    return (
        <div className="goal-feature-selector">
            <div className="goal-selector-input-wrapper">
                <input
                    type="text"
                    className="goal-selector-input"
                    placeholder="Search features by name..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setIsOpen(true);
                    }}
                    onFocus={() => setIsOpen(true)}
                />
                {isOpen && (
                    <div className="goal-selector-dropdown">
                        {loading ? (
                            <div className="goal-selector-loading">Loading features...</div>
                        ) : filteredFeatures.length > 0 ? (
                            filteredFeatures.map(feature => (
                                <div
                                    key={feature.id}
                                    className="goal-selector-item"
                                    onClick={() => handleSelect(feature)}
                                >
                                    <div className="goal-selector-item-name" style={{ color: feature.color || '#3b82f6' }}>
                                        {feature.name}
                                    </div>
                                    {feature.taskCount !== undefined && (
                                        <div className="goal-selector-item-meta">
                                            {feature.taskCount} task{feature.taskCount !== 1 ? 's' : ''}
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="goal-selector-empty">No features found</div>
                        )}
                    </div>
                )}
            </div>
            {isOpen && (
                <div
                    className="goal-selector-overlay"
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
};

export default GoalFeatureSelector;

